module.exports = __webpack_public_path__ + "static/media/google-plus.ea9843ea.svg";